<template>
  <BasicModal
    :title="'タスク送付'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container disp-scroll">
      <h2 class="msg-title">
        {{ sendTask.title }} をどなたに送付しますか？
      </h2>
      <div class="input-box">
        <p class="-label">送付メンバー</p>
        <b-taginput
          v-model="members"
          :data="filteredUsers"
          :allow-new="false"
          :open-on-focus="true"
          field="username"
          autocomplete
          icon="label"
          placeholder="メンバーを一人以上追加してください。">
        </b-taginput>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="sendUserTask(sendTask, members)">送付する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    sendTask: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredUsers () {
      // カレンダー関連で使用する場合はログイン不可ユーザーを表示しない
      return this.users.filter(user => {return user.user_hash != this.sendTask.user && user.permission < 3})
    }
  },
  data () {
    return {
      members: []
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', {
        flg: false,
        task: null
      })
    },
    sendUserTask (task, members) {
      this.$emit('sendUserTask', task, members)
      alert('送付いたしました。')
      this.cancel()
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 24px;
  height: 360px;
}
.msg-title {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 16px;
}
.input-field {
  padding: 8px;
  text-align: left;
  .-label {
    font-weight: 600;
    margin-bottom: 2px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalSendTask.vue